import { fetchClientGraphQL } from '~/hooks/graphql.js';

const nodeData = `
  nodes {
    author {
      node {
        name
        uri
      }
    }
    categories {
      nodes {
        name
        uri
      }
    }
    dateGmt
    uri
    title
    featuredImage {
      node {
        altText
        mediaItemUrl
      }
    }
  }
`;

const getAllPosts = `posts: posts(first: 10, where: { orderby: { field: DATE, order: DESC } }) { ${nodeData} }`;

// This performs an OR condition on categories
const getRelatedPosts = `
    posts(first: 3, where: { notIn: $notIn, categoryIn: $categoryIn }) {
      ${nodeData}
    }
`;

const getPosts = `posts(first: 3, where: { notIn: $notIn }) { ${nodeData} }`;

async function fetchSliderBlogs () {
  return new Promise(async (resolve, reject) => {
    await fetchClientGraphQL(`query blogPageQuery { ${ getAllPosts } }`)
      .then((data) => {
        resolve(data);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

const fetchRelatedBlogs = (excludeId, includeCategory) => {
  return new Promise((resolve, reject) => {
    const queryBody = includeCategory ? getRelatedPosts : getPosts;
    let queryParams = `$notIn: [ID] = ""`;

    if (excludeId) {
      queryParams = `$notIn: [ID] = "${excludeId}"`;
    }

    if (includeCategory) {
      queryParams += `, $categoryIn: [ID] = ["${includeCategory.join('", "')}"]`;
    }

    fetchClientGraphQL(`query blogPageQuery(${queryParams}) { ${ queryBody } }`)
      .then((data) => {
        resolve(data);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

export {
  fetchSliderBlogs,
  fetchRelatedBlogs,
}